// components/common/ProtectedRoute.tsx
import { useAuth } from "../../context/Auth/auth-context";
import { Navigate, useLocation } from "react-router-dom";
import { ref, get } from "firebase/database";
import { db } from "../../firebase";
import { useEffect, useState } from "react";
import { Role, isHostRole } from "../../types/authcontext.types";

interface ProtectedRouteProps {
  children: React.ReactNode;
  // requireAdmin: admin only (catalog management, presenter onboarding, bots).
  // requireHost: admin OR presenter (create/host/run quizzes).
  requireAdmin?: boolean;
  requireHost?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  requireHost = false,
}) => {
  const { user } = useAuth();
  const location = useLocation();
  const [role, setRole] = useState<Role | null>(null);

  useEffect(() => {
    const checkRole = async () => {
      if (!user) return;

      const roleRef = ref(db, `users/${user}/role`);
      const snapshot = await get(roleRef);
      setRole((snapshot.val() as Role) ?? 'audience');
    };

    checkRole();
  }, [user]);

  if (!user) {
    // Preserve the full target (path + query) through the sign-in round trip —
    // the broadcast QR's ?pin= must still be there after Google auth.
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} />;
  }

  const needsRole = requireAdmin || requireHost;

  if (needsRole && role === null) {
    return <div>Loading...</div>;
  }

  if (requireAdmin && role !== 'admin') {
    return <Navigate to="/unauthorized" />;
  }

  if (requireHost && !isHostRole(role ?? '')) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};
